import React, { Fragment } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import clsx from "clsx";

import { renderWithBreaks } from '@utils/translations';
import styles from "@components/contractTypesPage/calendars/calendarContract.module.scss";

const CalendarDaily = () => {
  const intl = useIntl();

  return (
    <Fragment>
      {renderWithBreaks(intl.formatMessage({ id: 'Contract Type Daily text' }))}
      <h3>{intl.formatMessage({ id: 'Example:' })}</h3>
      <div className={styles.calendarContract}>
        <div className={clsx(styles.calendarContract__availability, styles.calendarContract__availabilityNone)}>
          <FormattedMessage id={'January'} />
        </div>
        <div className={clsx(styles.calendarContract__availability, styles.calendarContract__availabilityNone)}>
          <FormattedMessage id={'February'} />
        </div>
        <div className={clsx(styles.calendarContract__availability, styles.calendarContract__availabilityBookedSecondHalf)}>
          <FormattedMessage id={'March'} />
          <span className={styles.calendarContract__moveDate} style={{right: "50%"}}>
            <FormattedMessage id={'Move in'} />: <strong>16 <FormattedMessage id={'March'} /></strong>
          </span>
          <span className={styles.calendarContract__contractDate} style={{right: "50%"}}>
            <FormattedMessage id={'Contract start'} />: <strong>16 <FormattedMessage id={'March'} /></strong>
          </span>
        </div>
        <div className={clsx(styles.calendarContract__availability, styles.calendarContract__availabilityBooked)}>
          <FormattedMessage id={'April'} />
        </div>
        <div className={clsx(styles.calendarContract__availability, styles.calendarContract__availabilityBookedFirstTwoThirds)}>
          <FormattedMessage id={'May'} />
          <span className={styles.calendarContract__moveDate} style={{right: "35%"}}>
            <FormattedMessage id={'Move out'} />: <strong>18 <FormattedMessage id={'May'} /></strong>
          </span>
          <span className={styles.calendarContract__contractDate} style={{right: "35%"}}>
            <FormattedMessage id={'Contract end'} />: <strong>18 <FormattedMessage id={'May'} /></strong>
          </span>
        </div>
        <div className={clsx(styles.calendarContract__availability, styles.calendarContract__availabilityNone)}>
          <FormattedMessage id={'June'} />
        </div>
      </div>
    </Fragment>
  );
};

export default CalendarDaily;
